// extracted by css-extract-rspack-plugin
export default {"OptionsCardsBox":"opportunity-form-single-or-series-step_OptionsCardsBox__UDRhi"};